import { useLocation } from 'react-router';

export const FindLocation = () => {
    const currentLocation = useLocation();
    return (
        currentLocation
    )
}